var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _ellipse, _path61, _ellipse2, _ellipse3, _path62, _ellipse4, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 200,
    viewBox: "0 0 274 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6104 74.8194L160.047 25.2662C169.334 21.9179 179.707 23.8806 187.129 30.39L251.914 87.2169C262.369 96.3873 264.193 111.981 256.135 123.316L209.741 188.589C201.696 199.909 186.4 203.321 174.306 196.495L108.425 159.307C97.3834 153.075 83.497 155.325 74.9887 164.724L64.174 176.672C49.3121 193.09 22.101 185.737 17.5322 164.067L5.2731 105.926C2.4809 92.6832 9.87919 79.4095 22.6104 74.8194Z",
    fill: "#EDECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1955 4.4112C16.349 4.4112 17.4546 3.39665 17.4008 2.20533C17.3476 1.01016 16.4319 0 15.1955 0C14.0415 0 12.9364 1.01455 12.9896 2.20533C13.0434 3.40049 13.9592 4.4112 15.1955 4.4112Z",
    fill: "#675EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61312 22.3038C3.76656 22.3038 4.87224 21.2892 4.81844 20.0985C4.76519 18.9033 3.84946 17.8926 2.61312 17.8926C1.45912 17.8926 0.353993 18.9071 0.407245 20.0985C0.461047 21.2931 1.37677 22.3038 2.61312 22.3038Z",
    fill: "#53E3B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265.155 71.7511C266.309 71.7511 267.414 70.7365 267.361 69.5457C267.307 68.3506 266.392 67.3398 265.155 67.3398C264.002 67.3398 262.896 68.3544 262.95 69.5457C263.003 70.7403 263.919 71.7511 265.155 71.7511Z",
    fill: "#53E3B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.859 116.242C238.013 116.242 239.118 115.227 239.065 114.036C239.011 112.841 238.096 111.83 236.859 111.83C235.705 111.83 234.6 112.845 234.654 114.036C234.707 115.231 235.623 116.242 236.859 116.242Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.144 60.8529C151.136 68.1112 140.05 61.7933 140.05 61.7933L141.474 53.0577L142.065 49.4321L149.414 43.6226L156.16 38.2891L161.144 60.8529Z",
    fill: "#F7CD9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.94 41.6572C154.174 49.0023 152.015 52.444 148.523 53.341C145.777 54.0509 142.548 53.3372 141.474 53.0561L142.065 49.4305L149.414 43.621L155.94 41.6572Z",
    fill: "#242526"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.031 43.5996L149.083 49.3734C148.442 49.9971 147.556 50.3023 146.661 50.2134L141.371 49.666C139.826 49.5046 138.656 48.2068 138.652 46.6537L138.647 42.5175L138.639 38.0081L138.63 31.055C138.618 25.0819 143.967 23.3125 143.967 23.3125C148.201 22.3155 151.196 23.8724 152.833 25.1538C153.741 25.8664 154.331 26.9101 154.505 28.0558L156.283 39.9049C156.486 41.2664 156.019 42.6411 155.031 43.5996Z",
    fill: "#F7CD9C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.816 36.0325C162.329 38.1412 161.036 40.2664 158.927 40.7797C156.818 41.293 153.825 39.8541 153.312 37.7453C152.799 35.6366 154.96 33.657 157.069 33.1437C159.177 32.6303 161.303 33.9238 161.816 36.0325Z",
    fill: "#F7CD9C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M200.678 135.775L198.502 136.263L157.347 145.503L123.638 135.16L122.068 119.018L97.4075 134.71L87.0946 100.856L120.876 67.2824C122.671 65.5003 124.983 64.3298 127.482 63.9395L139.78 62.0136L157.636 59.833L180.906 64.1306C186.679 65.5305 191.567 69.3614 194.307 74.6346L212.511 109.706L212.668 110.008C218.093 120.452 212.158 133.2 200.678 135.775Z",
    fill: "#4F46E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3641 77.5751L93.4465 73.6465L94.3336 93.6646L99.3345 117.704L105.533 135.369L64.7399 138.261L60.2085 126.923L54.8827 98.2361L53.3641 77.5751Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.921 150.228L150.292 164.182C151.382 165.291 151.471 169.016 149.194 169.507L99.5514 180.216C96.4885 180.877 92.3897 179.966 90.4293 178.161L67.9659 157.473C66.8646 156.459 66.8059 153.358 68.3661 152.51L112.442 149.176C114.433 148.901 117.309 149.365 118.921 150.228Z",
    fill: "#4F46E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.921 147.123L148.834 163.133C151.268 164.435 151.471 165.912 149.194 166.403L99.5519 177.111C96.4891 177.772 92.3902 176.862 90.4298 175.056L67.9664 154.369C66.8651 153.355 67.9884 152.217 70.4907 151.871L112.443 146.072C114.433 145.796 117.309 146.26 118.921 147.123Z",
    fill: "#675EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.424 162.523L113.378 168.226L104.25 169.93L96.6078 164.033L105.424 162.523Z",
    fill: "#4F46E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.946 160.894L123.218 166.391L114.483 168.021L106.491 162.341L114.946 160.894Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.088 159.328L132.643 164.631L124.275 166.192L115.971 160.718L124.088 159.328Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.871 157.826L141.68 162.946L133.657 164.443L125.072 159.161L132.871 157.826Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3932 156.767L104.51 161.869L95.7314 163.356L88.9073 158.091L97.3932 156.767Z",
    fill: "#53E3B6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.579 155.331L113.996 160.26L105.574 161.687L98.4221 156.604L106.579 155.331Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.415 153.952L123.104 158.717L115.017 160.088L107.568 155.177L115.415 153.952Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.922 152.625L131.856 157.236L124.085 158.553L116.368 153.804L123.922 152.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1685 151.587L96.5736 156.179L88.1224 157.486L81.9928 152.756L90.1685 151.587Z",
    fill: "#53E3B6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0353 150.318L105.724 154.764L97.5986 156.02L91.161 151.444L99.0353 150.318Z",
    fill: "#4F46E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.581 149.097L114.528 153.402L106.71 154.611L99.9917 150.182L107.581 149.097Z",
    fill: "#4F46E5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.823 147.917L123.006 152.091L115.477 153.255L108.503 148.964L115.823 147.917Z",
    fill: "#4F46E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5342 153.964L93.8858 172.849L102.951 170.974L80.2372 152.862L72.5342 153.964Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.219 123.287L113.843 125.518C113.843 125.518 115.61 133.327 122.21 132.955L112.821 136.208L105.291 149.506C105.291 149.506 107.452 151.317 110.775 150.546C112.372 150.175 113.79 149.256 114.868 148.02L118.323 144.056L121.373 154.428L137.92 162.144L145.245 160.006C145.245 160.006 144.767 155.774 141.328 155.03L142.362 147.907C142.362 147.907 152.163 150.965 157.349 145.505L143.219 123.287Z",
    fill: "#F7CD9C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129.674 136.815L118.323 144.057",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.568 137.883L125.201 144.78L127.984 157.513",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.722 139.771L132.888 145.505L135.332 160.664",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.364 128.693L122.21 132.957",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8827 98.2353L65.7952 103.852C67.5459 104.753 68.4699 106.72 68.0455 108.643L67.2341 112.322L68.0911 112.673C69.8956 113.414 70.9041 115.347 70.4781 117.251L69.48 121.713L69.1358 123.221C68.6516 125.468 66.3782 126.847 64.1613 126.237L64.1185 126.498C63.6837 129.155 61.2182 130.144 58.8103 128.94L52.2003 125.292L50.6834 123.92C49.6914 122.538 49.8182 120.177 49.8901 118.478L50.7998 97.0099L54.6027 94.4258L54.8827 98.2353Z",
    fill: "#F7CD9C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3083 106.9L67.2339 112.325",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3083 114.48L69.6561 120.926",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1614 126.238L53.9572 121.272",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3641 97.5312L60.1311 100.938",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.218 63.0491L139.457 54.319L161.144 53.916L162.836 61.7524C162.836 61.7524 148.516 72.3464 138.218 63.0491Z",
    fill: "#4F46E5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.015 105.764L143.219 123.287",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M178.013 95.6641L181.286 110.41",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M120.953 85.4043L122.068 119.017",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.629 37.5487C140.629 37.8238 140.406 38.0467 140.131 38.0467C139.856 38.0467 139.633 37.8238 139.633 37.5487C139.633 37.2737 139.856 37.0508 140.131 37.0508C140.406 37.0508 140.629 37.2737 140.629 37.5487Z",
    fill: "#242526"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.184 37.8689C147.459 37.8689 147.682 37.646 147.682 37.371C147.682 37.096 147.459 36.873 147.184 36.873C146.909 36.873 146.686 37.096 146.686 37.371C146.686 37.646 146.909 37.8689 147.184 37.8689Z",
    fill: "#242526"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.969 39.8756C152.969 38.5657 151.907 37.5039 150.597 37.5039C149.287 37.5039 148.225 38.5657 148.225 39.8756C148.225 41.1855 149.287 42.2473 150.597 42.2473C151.907 42.2473 152.969 41.1855 152.969 39.8756Z",
    fill: "#F4B17F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.276 40.2667C140.276 41.3147 139.593 42.2052 138.647 42.5192L138.639 38.0098C139.589 38.3194 140.276 39.2148 140.276 40.2667Z",
    fill: "#F4B17F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M143.735 35.5957L141.24 40.7865L143.706 40.9446L142.473 42.8134C142.473 42.8134 147.728 43.8268 149.66 41.3251",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M140.883 39.367H137.982C137.166 39.367 136.505 38.7055 136.505 37.8896V35.2715H141.962V38.2882C141.962 38.8844 141.479 39.367 140.883 39.367Z",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M145.705 39.367H148.605C149.421 39.367 150.083 38.7055 150.083 37.8896V35.2715H144.626V38.2882C144.626 38.8844 145.109 39.367 145.705 39.367Z",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M141.962 35.7269C141.962 35.7269 143.157 35.1439 144.626 35.7269",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M150.211 35.2724L156.26 33.9443",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M158.987 35.2715L157.447 36.4167C157.199 36.6012 157.315 36.9937 157.623 37.014L159.433 37.132",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M157.855 22.6196C159.164 22.7601 159.433 25.3058 159.433 25.3058L159 33.1247L156.718 36.613C150.996 35.0495 151.915 28.0722 151.915 28.0722C143.796 33.5452 135.135 30.0569 135.135 30.0569C133.87 29.5853 132.983 28.2018 133.026 26.8529C133.069 25.5046 134.044 24.2364 135.336 23.8472C135.09 22.9589 135.381 21.9729 135.969 21.2625C136.557 20.5521 137.418 20.1024 138.316 19.8922C139.213 19.6819 140.15 19.6973 141.067 19.7966C141.973 18.7936 143.427 18.1634 144.773 18.0355C146.119 17.9075 147.507 18.3006 148.587 19.1153L157.855 22.6196Z",
    fill: "#242526"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M142.033 55.8594L141.31 64.438",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M158.379 55.6289L159.307 64.0335",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M147.479 56.0195V65.414",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.561 55.7627L155.1 64.7515",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M160.155 55.4209L161.617 63.4077",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M140.342 55.6289L139.049 63.5268",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3338 93.666L60.2086 96.865",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3344 117.705L73.4717 119.6",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M200.678 135.776L198.502 136.264C197.183 133.744 196.44 130.876 196.44 127.834C196.44 118.493 203.457 110.789 212.51 109.707L212.667 110.008C218.093 120.453 212.158 133.2 200.678 135.776Z",
    fill: "#675EFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6566 18.6243L34.1787 16.1465L31.7009 18.6243L34.1787 21.1022L36.6566 18.6243Z",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.58 135.539L233.102 133.061L230.623 135.539L233.102 138.017L235.58 135.539Z",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4127,
    cy: 46.5013,
    rx: 1.098,
    ry: 1.098,
    fill: "#242526"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3582 43.8603C30.152 41.88 35.485 41.1954 40.6159 41.9717C47.6727 43.0395 54.1767 46.72 61.2785 47.426C66.7142 47.9662 72.3084 46.6508 76.9634 43.7999",
    stroke: "#242526",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2713,
    cy: 42.1966,
    rx: 1.098,
    ry: 1.098,
    fill: "#242526"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.771,
    cy: 168.686,
    rx: 1.098,
    ry: 1.098,
    fill: "#675EFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M203.716 166.043C208.51 164.063 213.843 163.378 218.974 164.154C226.031 165.222 232.535 168.903 239.636 169.609C245.072 170.149 250.666 168.833 255.321 165.982",
    stroke: "#675EFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.63,
    cy: 164.38,
    rx: 1.098,
    ry: 1.098,
    fill: "#675EFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M251.565 25.3555C260.961 37.1891 258.985 54.3991 247.152 63.7952C235.318 73.1913 218.108 71.2155 208.712 59.3818",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82068 142.02C11.6118 128.522 28.0598 123.085 41.558 129.876C55.0562 136.667 60.4934 153.115 53.7023 166.613",
    stroke: "#242526",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M214.47 41.9246C220.803 39.3858 224.478 33.6884 222.678 29.199C220.878 24.7095 214.286 23.1282 207.953 25.6669C201.62 28.2056 197.945 33.9031 199.745 38.3925C201.545 42.8819 208.138 44.4633 214.47 41.9246Z",
    fill: "#E39729"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M213.896 40.367C220.229 37.8283 223.904 32.1306 222.104 27.6409C220.304 23.1512 213.711 21.5696 207.378 24.1083C201.046 26.647 197.371 32.3447 199.171 36.8344C200.971 41.3241 207.563 42.9057 213.896 40.367Z",
    fill: "#EBA537"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M213.346 38.9971C218.609 36.887 221.663 32.1512 220.167 28.4194C218.671 24.6875 213.192 23.3729 207.928 25.483C202.664 27.5931 199.61 32.3289 201.106 36.0607C202.602 39.7925 208.082 41.1072 213.346 38.9971Z",
    fill: "#FFBB48"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M208.745 27.2653C212.594 25.7227 216.58 26.3825 218.332 28.6735C216.868 25.8819 212.525 24.9574 208.343 26.6334C203.967 28.3875 201.427 32.3255 202.671 35.4278C202.821 35.8023 203.02 36.147 203.26 36.4611C203.192 36.331 203.128 36.1981 203.072 36.0597C201.829 32.9574 204.369 29.0199 208.745 27.2653Z",
    fill: "#E39729"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M212.881 37.8698C217.258 36.1158 219.797 32.1784 218.554 29.0754C217.31 25.9725 212.754 24.8794 208.377 26.634C204.001 28.3886 201.461 32.3261 202.705 35.4284C203.948 38.5308 208.504 39.6239 212.881 37.8698Z",
    stroke: "#242526",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M210.678 33.2791C210.617 33.5481 210.474 33.8106 210.249 34.0664C210.023 34.3222 209.672 34.5457 209.196 34.7362C208.869 34.8674 208.536 34.9415 208.197 34.958C207.858 34.9744 207.546 34.908 207.262 34.7587C206.978 34.6093 206.766 34.3606 206.626 34.0126L206.604 33.9571L205.712 34.3151L205.648 34.157L206.552 33.7946C206.473 33.4894 206.482 33.1858 206.581 32.8827C206.68 32.5797 206.846 32.3063 207.081 32.0625C207.316 31.8182 207.584 31.6206 207.886 31.4691L207.95 31.6272C207.728 31.7408 207.511 31.9011 207.3 32.1075C207.09 32.3145 206.928 32.5566 206.815 32.835C206.701 33.1128 206.681 33.4059 206.753 33.7139L210.558 32.1888C210.561 31.7891 210.591 31.4581 210.644 31.1946C210.699 30.931 210.833 30.6736 211.047 30.4227C211.262 30.1712 211.596 29.9549 212.05 29.7732C212.593 29.5558 213.093 29.5064 213.551 29.6261C214.009 29.7458 214.335 30.045 214.527 30.5253L214.552 30.5885L215.545 30.1904L215.608 30.3486L214.604 30.751C214.71 31.1863 214.647 31.5893 214.416 31.9604C214.184 32.3315 213.877 32.6307 213.494 32.858L213.43 32.6999C213.734 32.5105 213.994 32.2503 214.211 31.9187C214.428 31.5871 214.492 31.2248 214.403 30.8317L210.777 32.2854C210.772 32.678 210.738 33.0096 210.678 33.2791ZM211.234 30.4984C211.042 30.7191 210.919 30.9519 210.866 31.1968C210.813 31.4416 210.785 31.7419 210.781 32.0988L214.352 30.6675L214.326 30.6044C214.163 30.1981 213.886 29.9319 213.494 29.804C213.102 29.6766 212.642 29.7189 212.113 29.9302C211.719 30.0883 211.426 30.2777 211.234 30.4984ZM207.732 34.7351C208.16 34.8328 208.626 34.7806 209.132 34.5775C209.541 34.4134 209.849 34.2168 210.055 33.9873C210.261 33.7578 210.394 33.519 210.455 33.2714C210.515 33.0238 210.548 32.7241 210.555 32.3727L206.806 33.8753L206.828 33.9308C207.003 34.3694 207.304 34.6373 207.732 34.7351Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M213.551 39.5104C219.214 37.24 222.501 32.1445 220.891 28.1293C219.282 24.1141 213.386 22.6996 207.722 24.9701C202.058 27.2405 198.772 32.336 200.382 36.3512C201.991 40.3664 207.887 41.7809 213.551 39.5104Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M221.797 27.7715L220.884 28.1377",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.374 36.3594L199.46 36.7256",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M213.803 40.1664L213.543 39.5186",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M207.715 24.9779L207.455 24.3301",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M220.771 34.6846L219.94 34.4854",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M201.317 30.0176L200.487 29.8184",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M204.975 41.0178L205.438 40.3008",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.819 24.2078L216.282 23.4902",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M222.178 31.0293L221.233 31.1292",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M200.025 33.3721L199.08 33.472",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M209.434 41.2652L209.532 40.5273",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M211.725 23.9736L211.823 23.2363",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M217.951 37.7623L217.351 37.3115",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M203.906 27.1925L203.306 26.7412",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M201.618 39.4879L202.355 38.8955",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M218.902 25.607L219.64 25.0146",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3581 165.326C22.708 169.56 29.4788 169.917 32.4802 166.124C35.4816 162.331 33.5776 155.824 28.2271 151.591C22.8766 147.357 16.1069 147 13.105 150.793C10.1042 154.586 12.0081 161.093 17.3581 165.326Z",
    fill: "#E39729"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4247 164.053C23.7747 168.287 30.5449 168.644 33.5468 164.851C36.5482 161.058 34.6443 154.551 29.2938 150.317C23.9432 146.083 17.173 145.726 14.1716 149.519C11.1702 153.312 13.0742 159.819 18.4247 164.053Z",
    fill: "#EBA537"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9156 163.544C34.4103 160.392 32.8276 154.983 28.3805 151.464C23.9335 147.946 18.3061 147.649 15.8114 150.802C13.3167 153.955 14.8994 159.363 19.3464 162.882C23.7935 166.401 29.4209 166.697 31.9156 163.544Z",
    fill: "#FFBB48"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2499 153.074C30.5011 155.647 31.9098 159.434 30.7926 162.092C32.4873 159.435 31.1313 155.206 27.5985 152.411C23.901 149.485 19.2219 149.238 17.1478 151.859C16.8974 152.175 16.6976 152.519 16.5444 152.885C16.6235 152.76 16.7069 152.639 16.7992 152.522C18.8733 149.901 23.5524 150.148 27.2499 153.074Z",
    fill: "#E39729"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20.103 161.932C23.8005 164.857 28.4796 165.104 30.5537 162.483C32.6279 159.861 31.3119 155.364 27.6144 152.439C23.9169 149.513 19.2378 149.266 17.1637 151.888C15.0896 154.509 16.4055 159.005 20.103 161.932Z",
    stroke: "#242526",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9924 157.738C22.7289 157.819 22.4303 157.825 22.0959 157.757C21.7621 157.688 21.3937 157.494 20.9913 157.177C20.7146 156.958 20.4852 156.706 20.3023 156.42C20.1195 156.133 20.0223 155.83 20.0108 155.509C19.9987 155.188 20.1096 154.881 20.3424 154.587L20.3792 154.54L19.6249 153.944L19.7308 153.81L20.4945 154.414C20.7201 154.194 20.9886 154.051 21.3004 153.986C21.6122 153.922 21.9323 153.93 22.2606 154.013C22.5889 154.095 22.8942 154.23 23.1758 154.416L23.0698 154.55C22.8607 154.413 22.6142 154.305 22.3303 154.225C22.046 154.145 21.7555 154.125 21.458 154.165C21.1604 154.205 20.8958 154.333 20.6647 154.549L23.8796 157.092C24.2282 156.897 24.5302 156.757 24.7855 156.673C25.0407 156.589 25.3312 156.578 25.6556 156.639C25.9801 156.701 26.3342 156.883 26.7174 157.186C27.1763 157.549 27.4673 157.959 27.5914 158.416C27.7155 158.872 27.6172 159.303 27.296 159.709L27.2537 159.762L28.0926 160.427L27.9867 160.56L27.1379 159.889C26.8124 160.196 26.4313 160.342 25.9949 160.326C25.5579 160.31 25.145 160.192 24.7575 159.972L24.8634 159.839C25.1785 160.008 25.5343 160.105 25.9296 160.128C26.3254 160.151 26.6713 160.026 26.9683 159.755L23.9043 157.33C23.5601 157.521 23.2559 157.657 22.9924 157.738ZM25.6814 156.839C25.3943 156.782 25.1313 156.791 24.8925 156.867C24.6537 156.943 24.3786 157.067 24.0674 157.241L27.0841 159.628L27.1264 159.575C27.3976 159.231 27.4915 158.858 27.4069 158.455C27.3229 158.051 27.0572 157.673 26.6109 157.319C26.2782 157.056 25.968 156.896 25.6814 156.839ZM20.2645 155.906C20.3924 156.326 20.6696 156.704 21.0973 157.043C21.4426 157.316 21.7665 157.485 22.0679 157.55C22.3693 157.615 22.6427 157.611 22.8876 157.541C23.1324 157.47 23.4091 157.35 23.7166 157.18L20.5488 154.674L20.5121 154.72C20.2194 155.091 20.1371 155.486 20.2645 155.906Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9991 163.327C23.7836 167.113 29.8385 167.432 32.5225 164.04C35.2066 160.648 33.5041 154.829 28.7191 151.043C23.9346 147.257 17.8797 146.937 15.1956 150.329C12.5116 153.721 14.214 159.54 18.9991 163.327Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M33.295 164.652L32.5226 164.041",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1956 150.33L14.4237 149.719",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5659 163.874L18.9991 163.326",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7191 151.043L29.1523 150.496",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7881 167.192L26.5482 166.373",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1697 147.992L20.9298 147.173",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4442 156.634L14.2963 156.679",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4218 157.688L34.2738 157.733",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6593 166.6L30.1027 165.83",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6157 148.542L17.0596 147.771",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4443 160.63L16.1328 160.348",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5854 154.024L32.2739 153.742",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7168 166.281L22.8107 165.536",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9078 148.839L25.0012 148.095",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1006 152.962L13.9806 153.308",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7374 161.062L34.6175 161.407",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M263.134 144.816C269.135 142.07 271.774 134.98 269.029 128.978C266.283 122.977 259.193 120.338 253.191 123.083C247.19 125.829 244.551 132.92 247.297 138.921C250.042 144.922 257.133 147.561 263.134 144.816Z",
    fill: "#EBA537"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M267.461 137.522C269.432 132.402 266.88 126.654 261.76 124.683C256.641 122.711 250.893 125.264 248.922 130.383C246.95 135.502 249.502 141.25 254.622 143.222C259.741 145.193 265.49 142.641 267.461 137.522Z",
    fill: "#FFBB48"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M265.899 136.921C267.538 132.664 265.416 127.885 261.159 126.245C256.903 124.606 252.123 126.728 250.484 130.985C248.845 135.241 250.967 140.021 255.224 141.66C259.481 143.3 264.26 141.177 265.899 136.921Z",
    stroke: "#242526",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M259.312 134.732C259.547 134.985 259.709 135.286 259.799 135.636C259.888 135.987 259.844 136.393 259.665 136.856C259.543 137.175 259.355 137.451 259.103 137.686C258.85 137.921 258.532 138.073 258.148 138.141C257.765 138.21 257.334 138.152 256.857 137.968L256.781 137.939L256.447 138.807L256.23 138.723L256.568 137.844C256.184 137.655 255.872 137.408 255.632 137.104C255.393 136.8 255.237 136.474 255.167 136.127C255.097 135.78 255.103 135.448 255.184 135.13L255.401 135.214C255.343 135.449 255.339 135.718 255.39 136.02C255.44 136.321 255.566 136.619 255.769 136.913C255.971 137.208 256.263 137.452 256.644 137.649L258.069 133.948C257.652 133.63 257.326 133.349 257.092 133.104C256.857 132.861 256.694 132.569 256.6 132.229C256.506 131.89 256.544 131.5 256.714 131.058C256.917 130.53 257.264 130.163 257.755 129.958C258.245 129.752 258.82 129.776 259.478 130.029L259.565 130.063L259.937 129.097L260.153 129.18L259.777 130.157C260.319 130.432 260.694 130.792 260.9 131.237C261.106 131.682 261.177 132.121 261.11 132.552L260.893 132.469C260.936 132.119 260.869 131.743 260.693 131.338C260.516 130.934 260.186 130.605 259.702 130.352L258.344 133.879C258.753 134.196 259.076 134.48 259.312 134.732ZM256.828 132.168C256.907 132.469 257.055 132.733 257.27 132.962C257.485 133.19 257.779 133.446 258.151 133.731L259.489 130.258L259.402 130.224C258.845 130.01 258.343 129.981 257.896 130.137C257.45 130.293 257.128 130.628 256.93 131.142C256.783 131.526 256.749 131.868 256.828 132.168ZM258.498 137.815C258.942 137.612 259.259 137.265 259.448 136.773C259.601 136.375 259.639 136.018 259.562 135.701C259.484 135.385 259.339 135.109 259.126 134.873C258.914 134.638 258.625 134.379 258.26 134.097L256.856 137.743L256.931 137.772C257.532 138.004 258.055 138.018 258.498 137.815Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M260.706 144.348C266.441 142.954 269.961 137.174 268.566 131.439C267.172 125.703 261.393 122.184 255.657 123.578C249.922 124.972 246.402 130.752 247.797 136.487C249.191 142.223 254.97 145.742 260.706 144.348Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M262.374 123.089L262.032 123.978",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M254.351 143.926L254.009 144.814",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M269.054 138.134L268.165 137.792",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M248.218 130.111L247.33 129.769",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M268.83 129.229L267.959 129.616",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M248.424 138.289L247.553 138.676",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M262.914 144.589L262.528 143.719",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M253.855 124.184L253.468 123.313",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M266.104 125.415L265.457 126.113",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M250.926 141.79L250.279 142.488",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M266.728 141.866L266.029 141.218",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 126.687L249.655 126.04",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M269.823 133.511L268.871 133.547",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M247.511 134.356L246.56 134.393",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M258.633 145.582L258.596 144.631",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M257.786 123.273L257.75 122.321",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1a0b71a235e3974faec7d5a64eb3f1da.svg";
export { ForwardRef as ReactComponent };